import React, { useEffect } from 'react';
import BackButton from '../../components/common/BackButton/BackButton';
import '../PrivacyPolicy/PrivacyPolicy.css';

export default function TermsOfUse() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page-container">
      <div style={{ marginBottom: '16px' }}>
        <BackButton fallbackTo="/" />
      </div>

      <header className="legal-header">
        <span className="legal-badge">Legal Documentation</span>
        <h1 className="legal-title">Terms of Use</h1>
        <p className="legal-meta">Last Updated: October 2026 • Tiwari Syndicate Private Limited</p>
      </header>

      <div className="legal-intro-box">
        Welcome to <strong>Tiwari Syndicate</strong>. By accessing or using our website, browsing our product catalog, placing orders, or requesting construction material quotations, you agree to comply with and be bound by the following Terms of Use. Please read these terms carefully.
      </div>

      <div className="legal-content-grid">
        <section className="legal-section-card">
          <div className="legal-section-header">
            <span className="legal-section-num">1</span>
            <h2 className="legal-section-title">Acceptance of Terms</h2>
          </div>
          <div className="legal-body">
            <p>These Terms of Use govern all visits, orders, quotes, and interactions with Tiwari Syndicate. If you do not agree to these terms, please refrain from using our website or procuring services through our platform.</p>
          </div>
        </section>

        <section className="legal-section-card">
          <div className="legal-section-header">
            <span className="legal-section-num">2</span>
            <h2 className="legal-section-title">Eligibility & Account Security</h2>
          </div>
          <div className="legal-body">
            <p>To register an account or request wholesale/contractor pricing, you must be legally competent to enter into binding contracts under the Indian Contract Act, 1872. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</p>
          </div>
        </section>

        <section className="legal-section-card">
          <div className="legal-section-header">
            <span className="legal-section-num">3</span>
            <h2 className="legal-section-title">Product Information, Specifications & Pricing</h2>
          </div>
          <div className="legal-body">
            <p>We supply premium construction materials, including plywood, laminates, sanitary ware, hardware, and decorative solutions.</p>
            <ul className="legal-list">
              <li><strong>Catalog Accuracy:</strong> While we endeavor to ensure high accuracy in technical specifications, dimensions, and images, actual physical textures and grain variations may differ naturally.</li>
              <li><strong>Pricing & Quotes:</strong> Prices displayed or quoted are subject to market conditions, raw material taxes, and transport costs. Formal quotations are valid for the specific period mentioned thereon.</li>
              <li><strong>Availability:</strong> Products listed are subject to warehouse stock availability and supplier lead times.</li>
            </ul>
          </div>
        </section>

        <section className="legal-section-card">
          <div className="legal-section-header">
            <span className="legal-section-num">4</span>
            <h2 className="legal-section-title">Orders, Billing & Payment Terms</h2>
          </div>
          <div className="legal-body">
            <p>All purchase orders placed through the website or our sales representatives are subject to verification and formal confirmation.</p>
            <ul className="legal-list">
              <li>Orders require standard payment or confirmed credit terms before dispatch.</li>
              <li>Official GST invoices and e-way bills are issued for all eligible transactions in compliance with Indian tax regulations.</li>
              <li>Tiwari Syndicate reserves the right to hold or cancel orders in cases of pricing inaccuracies, inventory shortages, or credit non-approvals.</li>
            </ul>
          </div>
        </section>

        <section className="legal-section-card">
          <div className="legal-section-header">
            <span className="legal-section-num">5</span>
            <h2 className="legal-section-title">Dispatch, Delivery & Site Receipt</h2>
          </div>
          <div className="legal-body">
            <p>Deliveries are scheduled in coordination with logistics teams:</p>
            <ul className="legal-list">
              <li>Customers or site representatives must ensure safe, clear vehicular access for transport unloading at the delivery site.</li>
              <li>The recipient is required to verify material quantities and condition against the delivery challan upon arrival.</li>
              <li>Any claims for physical transit damage or visible shortages must be reported within 24 hours of delivery.</li>
            </ul>
          </div>
        </section>

        <section className="legal-section-card">
          <div className="legal-section-header">
            <span className="legal-section-num">6</span>
            <h2 className="legal-section-title">Intellectual Property</h2>
          </div>
          <div className="legal-body">
            <p>All brand names, trademarks, logos, catalog layouts, product descriptions, photography, and software code on this website are the proprietary property of Tiwari Syndicate or licensed from respective manufacturer partners. Unauthorized copying, scraping, or commercial exploitation is strictly prohibited.</p>
          </div>
        </section>

        <section className="legal-section-card">
          <div className="legal-section-header">
            <span className="legal-section-num">7</span>
            <h2 className="legal-section-title">Limitation of Liability</h2>
          </div>
          <div className="legal-body">
            <p>Tiwari Syndicate shall not be held liable for indirect, incidental, or consequential damages resulting from project delays, site-level installation errors, or Force Majeure events beyond our reasonable control (including severe weather, transit strikes, or natural disasters).</p>
          </div>
        </section>

        <section className="legal-section-card">
          <div className="legal-section-header">
            <span className="legal-section-num">8</span>
            <h2 className="legal-section-title">Governing Law & Jurisdiction</h2>
          </div>
          <div className="legal-body">
            <p>These Terms shall be governed by and construed in accordance with the laws of India. Any disputes arising out of or related to these terms shall be subject to the exclusive jurisdiction of the competent courts in <strong>Muzaffarpur, Bihar, India</strong>.</p>
          </div>
        </section>

        <div className="legal-contact-card">
          <h4>Contact & Inquiries</h4>
          <p style={{ margin: '0 0 8px 0', fontSize: '14px', lineHeight: '1.6' }}>
            For legal notices, contract terms, or billing clarifications, please get in touch with our administrative office:
          </p>
          <div style={{ fontSize: '14px', lineHeight: '1.8' }}>
            <strong>Tiwari Syndicate Private Limited</strong><br />
            Address: Tiwari Syndicate Private Limited, Majhauli Khetal, Near Majhaulia Chowk, Majhaulia, Muzaffarpur, Bihar, 842001<br />
            Phone: 0621-406 9248 / +91 7667158891<br />
            Email: <a href="mailto:enquiry@tiwarisyndicate.com" style={{ color: 'inherit', fontWeight: '600' }}>enquiry@tiwarisyndicate.com</a>
          </div>
        </div>
      </div>
    </div>
  );
}
